import 'css-chunksrc/client/pages/assistantPage/styles.scss';export default {
  "assistantPage": "_assistantPage_qfnis_1",
  "header": "_header_qfnis_8",
  "title": "_title_qfnis_17",
  "profileNavigation": "_profileNavigation_qfnis_24",
  "main": "_main_qfnis_34"
};